import { render, staticRenderFns } from "./recipe_details.vue?vue&type=template&id=15e194ea&scoped=true&"
import script from "./recipe_details.vue?vue&type=script&lang=js&"
export * from "./recipe_details.vue?vue&type=script&lang=js&"
import style0 from "./recipe_details.vue?vue&type=style&index=0&id=15e194ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e194ea",
  null
  
)

export default component.exports